import { forwardRef } from 'react';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { ThumbsUpIcon, ThumbsDownIcon, ThumbsUpDownTableIcon } from '.';

const SvgIcon = styled.div`
  cursor: pointer;
  display: inline-block;
  height: 16px;
  line-height: 16px;
  outline: none;
  &:focus {
    ${tokens.focus()};
  }
`;

export interface ThumbsUpDownTableButtonProps {
  answer: boolean | null;
  labelNoAnswer: string;
  color?: string;
}

export const ThumbsUpDownTableButton = forwardRef<HTMLDivElement, ThumbsUpDownTableButtonProps>(
  (props, ref): JSX.Element => {
    const { answer, labelNoAnswer, color } = props;
    const { t } = useTranslation('feedback', { keyPrefix: 'survey-response.feedback-tooltip' });

    if (answer) {
      return (
        <SvgIcon ref={ref} role="button" tabIndex={0} aria-label={t('thumbs-up-answer-label')}>
          <ThumbsUpIcon size={16} />
        </SvgIcon>
      );
    }

    if (answer === false) {
      return (
        <SvgIcon ref={ref} role="button" tabIndex={0} aria-label={t('thumbs-down-answer-label')}>
          <ThumbsDownIcon size={16} />
        </SvgIcon>
      );
    }

    return (
      <SvgIcon ref={ref} role="button" tabIndex={0} aria-label={labelNoAnswer}>
        <ThumbsUpDownTableIcon color={color} />
      </SvgIcon>
    );
  },
);
